import React from 'react';
import { Sun, Moon, Clock, Droplets } from 'lucide-react';

interface HeaderEnvironmentalDisplayProps {
  environmentalState: any;
  openTooltip: string | null;
  handleTooltipToggle: (id: string) => void;
}

const HeaderEnvironmentalDisplay: React.FC<HeaderEnvironmentalDisplayProps> = ({ environmentalState, openTooltip, handleTooltipToggle }) => {
  if (!environmentalState.enabled) return null;

  const timeOfDay = environmentalState.currentTimeOfDay;
  const day = environmentalState.dayIndex + 1;
  const humidity = Math.round(environmentalState.humidity);

  const timeIcon = {
    MORNING: <Sun size={12} className="text-yellow-300" />,
    AFTERNOON: <Sun size={12} className="text-orange-300" />,
    NIGHT: <Moon size={12} className="text-blue-200" />,
  }[timeOfDay];

  const timeOfDayText = timeOfDay.charAt(0) + timeOfDay.slice(1).toLowerCase();

  return (
    <div
      className="flex items-center gap-1 bg-black bg-opacity-20 px-1.5 py-0.5 rounded-full text-xs environmental-tooltip-trigger tooltip-trigger cursor-pointer"
      onClick={() => handleTooltipToggle('environmental')}
    >
      <div className="flex items-center gap-0.5" title={`Day ${day}`}>
        <Clock size={12} />
        <span className="hidden sm:inline text-xs">{day}</span>
      </div>
      <div className="w-px h-2 bg-white/20 hidden sm:block"></div>
      <div className="flex items-center gap-0.5" title={`Time of Day: ${timeOfDayText}`}>
        {timeIcon}
        <span className="hidden sm:inline text-xs">{timeOfDayText.slice(0, 3)}</span>
      </div>
      <div className="w-px h-2 bg-white/20 hidden sm:block"></div>
      <div className="flex items-center gap-0.5" title={`Humidity: ${humidity}%`}>
        <Droplets size={12} className="text-cyan-300" />
        <span className="hidden sm:inline text-xs">{humidity}%</span>
      </div>
      <div className={`environmental-tooltip ${openTooltip === 'environmental' ? 'tooltip-visible' : ''}`}>
        <h4 className="font-bold mb-1 border-b border-gray-500 pb-1">Environmental Effects</h4>
        <ul className="list-disc list-inside text-xs mt-1 space-y-1">
          <li>Time: {timeOfDayText}</li>
          <li>Humidity: {humidity}%</li>
        </ul>
      </div>
    </div>
  );
};

export default HeaderEnvironmentalDisplay;
